// Install the angularjs.TypeScript.DefinitelyTyped NuGet package
namespace Cfnc {
    "use strict";

    interface IfilterWatch extends ng.IDirective {
    }

    interface IfilterWatchScope extends ng.IScope {
        filters: Array<IAvaliableFiltersGroup>;
        onChange: () => void;
        currentPage: number;
    }

    class FilterWatch implements IfilterWatch {
        static directiveId: string = "filterWatch";
        restrict: string = "A";
        scope: any = {
            filters: "=filterWatch",
            onChange: "&",
            currentPage: "="
        };

        constructor($window: ng.IWindowService){
        
        }

        link = (scope: IfilterWatchScope, element, attrs) => {
            scope.$watch("filters", (newValue, oldValue) => {
                scope.currentPage = 1;
                scope.onChange();
            }, true);
        };

    }

    angular.module("app").directive(FilterWatch.directiveId, ["$window", $window =>
        new FilterWatch($window)
    ]);
}